import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const HubBodyTheme = () => {
  const location = useLocation();
  useEffect(() => {
    const hub = location.pathname.startsWith("/hub") || location.pathname.startsWith("/book");
    document.body.classList.toggle("hub-scope", hub);
    return () => document.body.classList.remove("hub-scope");
  }, [location.pathname]);
  return null;
};
